import classNames from 'classnames';
import ConstructorText from '@/shared/components/constructor/ConstructorText';
import { ImageShape, VideoShape } from '@/shared/lib/types';
import ConstructorCompanies from '../ConstructorCompanies';
import ConstructorImage from '../ConstructorImage';
import ConstructorPeople from '../ConstructorPeople';
import ConstructorQuote from '../ConstructorQuote';
import ConstructorSlider from '../ConstructorSlider';
import ConstructorVideo from '../ConstructorVideo';

export type ConstructorBlock<T extends Record<string, any> = Record<string, any>> = {
    name: 'text' | 'image' | 'video' | 'quote' | 'slider' | 'people' | 'companies';
    properties: T;
};

export type GalleryConstructorBlock = ConstructorBlock;

export type ImageConstructorBlock = ConstructorBlock;

export type ListConstructorBlock = ConstructorBlock;

export type AppConstructor = (GalleryConstructorBlock | ImageConstructorBlock | ListConstructorBlock)[];

export type ApiConstructorBlock = {
    block: 'wysiwyg' | 'image' | 'video' | 'slider-images' | 'quote' | 'text' | 'people' | 'companies';
    properties: Partial<{
        text: string;
        video: VideoShape;
        image: ImageShape;
        images: ImageShape[];
        quote: {
            name?: string;
            position?: string;
            quote: string;
            image?: ImageShape;
        };
    }>;
};

export type ApiConstructor = ApiConstructorBlock[];

type Props = React.HTMLAttributes<HTMLElement> & {
    blocks: AppConstructor;
    navData?: { id: string; text: string }[];
};

const blockDict: Record<ConstructorBlock['name'], React.ElementType> = {
    text: ConstructorText,
    image: ConstructorImage,
    video: ConstructorVideo,
    quote: ConstructorQuote,
    slider: ConstructorSlider,
    people: ConstructorPeople,
    companies: ConstructorCompanies,
};

const Constructor = ({ blocks, navData = [], ...props }: Props) => {
    return (
        <div {...props} className={classNames('constructor', props.className)}>
            {blocks.map((item, i) => {
                const Component = blockDict[item.name];
                const id = navData.find((navItem) => navItem.text === item.properties.title)?.id;

                return Component ? <Component key={i} id={id} properties={item.properties} /> : null;
            })}
        </div>
    );
};

export default Constructor;
